export default __webpack_public_path__ + "static/media/fraz.7dd09891.png";